export interface IAssets {
	logo128: string
	logoMenu: string
	vendor: string
	vendorEmail: string
}

const ASSETS: IAssets = {
	logo128: '/assets/logo/logo_128.png',
	logoMenu: '/assets/logo/logo_menu.png',
	vendor: 'Certisep',
	vendorEmail: 'certisep@certisep.com'
}

/**
 * Singleton class to manage assets
 */
export class Assets implements IAssets {
	private _assets: IAssets
	private static _instance: Assets

	private constructor(assets?: IAssets) {
		this._assets = assets || ASSETS
	}

	//Set assets Map
	public setAssetsMap(assets: IAssets): void {
		this._assets = assets
	}

	public get logo128(): string {
		return this._getAssetKey('logo128')
	}

	public get logoMenu(): string {
		return this._getAssetKey('logoMenu')
	}
	public get vendor(): string {
		return this._getAssetKey('vendor')
	}
	public get vendorEmail(): string {
		return this._getAssetKey('vendorEmail')
	}

	private _getAssetKey(key: keyof IAssets): string {
		let output = ''
		if (this._assets[key]) {
			output = this._assets[key]
		} else {
			output = ASSETS[key]
			console.warn(`Asset ${key} not found in assets map, using default asset ${ASSETS[key]}`)
		}
		return output
	}

	public static getInstance(assets?: IAssets): Assets {
		if (!Assets._instance) {
			Assets._instance = new Assets(assets)
		}
		if (assets) {
			Assets._instance.setAssetsMap(assets)
		}
		return Assets._instance
	}
}
